class LumaluxStickyCart extends HTMLElement {
  connectedCallback() {
    this.formElement = document.forms[this.getAttribute('form')];
    if (!this.formElement) return;
    this.footerElement = document.querySelector('.shopify-section--footer');
    this.scheduleUpdate = () => {
      if (this.frame) return;
      this.frame = requestAnimationFrame(() => {
        this.frame = null;
        const formAbove = this.formElement.getBoundingClientRect().bottom < 0;
        const footer = this.footerElement?.getBoundingClientRect();
        const footerVisible = footer && footer.top < innerHeight && footer.bottom > 0;
        this.classList.toggle('is-visible', formAbove && !footerVisible);
      });
    };
    window.addEventListener('scroll', this.scheduleUpdate, { passive: true });
    window.addEventListener('resize', this.scheduleUpdate);
    this.observer = new IntersectionObserver(this.scheduleUpdate);
    this.observer.observe(this.formElement);
    if (this.footerElement) this.observer.observe(this.footerElement);
    this.resizeObserver = new ResizeObserver(this.scheduleUpdate);
    this.resizeObserver.observe(document.body);
    this.scheduleUpdate();
  }

  disconnectedCallback() {
    window.removeEventListener('scroll', this.scheduleUpdate);
    window.removeEventListener('resize', this.scheduleUpdate);
    this.observer?.disconnect();
    this.resizeObserver?.disconnect();
    cancelAnimationFrame(this.frame);
    this.frame = null;
  }
}

if (!customElements.get('lumalux-sticky-cart')) {
  customElements.define('lumalux-sticky-cart', LumaluxStickyCart);
}
